var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16536 3.9165C2.70874 3.9165 2.33203 4.29322 2.33203 4.74983V14.2498C2.33203 14.7065 2.70877 15.0832 3.16536 15.0832H15.832C16.2887 15.0832 16.6654 14.7065 16.6654 14.2498V4.74983C16.6654 4.29324 16.2887 3.9165 15.832 3.9165H3.16536ZM0.832031 4.74983C0.832031 3.46479 1.88032 2.4165 3.16536 2.4165H15.832C17.1171 2.4165 18.1654 3.46477 18.1654 4.74983V14.2498C18.1654 15.5349 17.1171 16.5832 15.832 16.5832H3.16536C1.8803 16.5832 0.832031 15.5349 0.832031 14.2498V4.74983Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0298 4.31997C18.2673 4.6593 18.1848 5.12695 17.8454 5.36449L9.92874 10.9062C9.6705 11.087 9.32679 11.087 9.06855 10.9062L1.15188 5.36449C0.812539 5.12695 0.730014 4.6593 0.967551 4.31997C1.20509 3.98063 1.67274 3.8981 2.01207 4.13564L9.49864 9.37627L16.9852 4.13564C17.3246 3.8981 17.7922 3.98063 18.0298 4.31997Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2042a15e5e269d05c1c55d2ce2843cb6.svg";
export { ForwardRef as ReactComponent };